import React, { useState } from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import config from '../../config';
import MarkTopicAsReadButton from '../../components/MarkTopicAsReadButton';
import { FooterMobile } from '../../Layout/FooterMobile';
import { useChecklist } from '../../context/ChecklistContext';
import { getCurrentChecklistId } from '../../utils/checklistUtils';

const EmailOptions: React.FC = () => {
    const { HOME, SCHOOL_PREP_CHECKLIST, EMAIL_SETUP } = config.app.routes;

    const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
        desktop: false,
        mobile: false,
    });

    const toggleExpand = (section: string) => {
        setExpandedSections((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };
    // Get checklist data & currentChecklistId from ChecklistContext
    const { checklistData } = useChecklist();
    const currentChecklistId = getCurrentChecklistId(checklistData, "EMAIL_OPTIONS");
    
return (

<div className="home-layout">
    <div className="sidebar-wrapper">
    <Sidebar />
    </div>
    <div className="body-wrapper-content">
        <div className="row">
            <div className="col-12">
                <Header />
                <main id="main" role="main" tabIndex={-1}>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="d-none d-sm-block">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <a href={HOME}>Home</a>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <a href={SCHOOL_PREP_CHECKLIST}>School Prep Checklist</a>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <a href={EMAIL_SETUP}>School Email</a>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <span>Email Options</span>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-2 wp-block-columns-is-layout-flex">
                            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: "66.66%" }}>
                                <h1 className="wp-block-heading">Email Options</h1>

                                <h4 className="wp-block-heading">
                                    The easiest way for you to check your school email is through your Online School (OLS) account. But there
                                    are some other options:&nbsp;
                                </h4>

                                <div style={{ height: "40px" }} aria-hidden="true" className="wp-block-spacer"></div>

                                <h2 className="wp-block-heading">Check Email Through the OLS&nbsp;</h2>

                                <div className="wp-block-columns is-not-stacked-on-mobile gap-2 is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                                    <div
                                        className="wp-block-column d-flex align-items-center is-layout-flow wp-block-column-is-layout-flow"
                                        style={{ flexBasis: "72px" }}
                                    >
                                        <figure className="wp-block-image size-large is-resized">
                                            <img
                                                decoding="async"
                                                width="64"
                                                height="64"
                                                src="https://welcome.k12.com/wp-content/uploads/2024/05/Icon_Email.svg"
                                                alt=""
                                                className="wp-image-411"
                                                style={{ width: "56px" }}
                                            />
                                        </figure>
                                    </div>

                                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                        <p className="mb-0 size-bigger">
                                            Click the mail icon at the top of your screen to go to your inbox, create a new message, or contact a
                                            teacher.&nbsp;
                                        </p>
                                    </div>
                                </div>

                                <div style={{ height: "32px" }} aria-hidden="true" className="wp-block-spacer"></div>

                                {/* Desktop Section */}
                                <div className="wp-block-k12-section container-fluid bg-color-light-gray-3 p-5">
                                <div className="row">
                                <div className="col-12 g-0">
                                    <p className="eyebrow has-blue-3-color has-text-color has-link-color">
                                        <strong>DESKTOP</strong>
                                    </p>

                                    <h2 className="wp-block-heading">
                                        Install Office 365 on Your Personal Computer (Optional)
                                    </h2>

                                    <div className="wp-block-k12-show-more-block m-0">
                                        <div className="accordion" id="desktopAccordion">
                                            <div className="accordion-item">
                                                <div id="desktopContent" className={`accordion-collapse collapse ${expandedSections.desktop ? 'show'
                                                    : ''}`} aria-labelledby="desktopHeader" data-bs-parent="#desktopAccordion">
                                                    <div className="accordion-body bg-transparent p-sm-2rem p-0">

                                                        <p className="size-bigger">
                                                            You can view mail and use additional tools within Office 365. Office 365
                                                            comes preinstalled on school-issued computers, but if you need to download it
                                                            onto a personal computer, here’s how:&nbsp;
                                                        </p>

                                                        <ol className="wp-block-list">
                                                            <li>
                                                                Go to the Microsoft Office website at{' '}
                                                                <a
                                                                    href="https://office.com"
                                                                    target="_blank"
                                                                    rel="noreferrer noopener"
                                                                >
                                                                    https://office.com
                                                                </a>
                                                                .&nbsp;
                                                            </li>
                                                            <li>
                                                                Click the Sign In button and then use your online school username and
                                                                password to access your O365 account.&nbsp;
                                                            </li>
                                                            <li>
                                                                Select <strong>Office 365 apps</strong> from the “Install Office” drop
                                                                down.&nbsp;
                                                            </li>
                                                            <li>
                                                                You will then install the application from the download folder in your
                                                                browser.&nbsp;
                                                            </li>
                                                            <li>
                                                                Once the installation is complete, close the dialog box and launch the O365
                                                                application from the Windows Start Menu or the Applications Menu (if using a
                                                                Mac).&nbsp;
                                                            </li>
                                                            <li>
                                                                After the application opens, make sure you are signed into your account. You
                                                                can sign in using your K12 online school username and password.&nbsp;
                                                            </li>
                                                        </ol>

                                                        <p>
                                                            Need to locate or update your account info? Access account settings on the My
                                                            Account page at the top of this site, or in your OLS.
                                                        </p>
                                                    </div>
                                                </div>
                                                <span className="accordion-header" id="desktopHeader">
                                                    <button className={`accordion-button ${expandedSections.desktop ? '' : 'collapsed'}`} type="button"
                                                        onClick={() => toggleExpand('desktop')}
                                                        aria-expanded={expandedSections.desktop}
                                                        aria-controls="desktopContent">
                                                        <span className="show-more">Show More</span>
                                                        <span className="show-less">Show Less</span>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                </div>

                                {/* Mobile Section */}
                                <div className="wp-block-k12-section container-fluid bg-color-light-gray-3 p-5">
                                    <div className="row">
                                        <div className="col-12 g-0">
                                            <p className="eyebrow has-blue-3-color has-text-color has-link-color">
                                                <strong>MOBILE</strong>
                                            </p>
                                            <h2 className="wp-block-heading">View Email on Your Mobile Device (Optional)&nbsp;</h2>

                                            <div className="wp-block-k12-show-more-block">
                                                <div className="accordion" id="mobileAccordion">
                                                    <div className="accordion-item">
                                                        <div id="mobileContent" className={`accordion-collapse collapse ${expandedSections.mobile ? 'show'
                                                            : ''}`} aria-labelledby="mobileHeader" data-bs-parent="#mobileAccordion">
                                                            <div className="accordion-body bg-transparent p-sm-2rem p-0">

                                                                <p className="size-bigger">
                                                                    If students have a smartphone and wish to receive school email messages with the Outlook application, here are the setup instructions:
                                                                </p>
                                                                <p>
                                                                    <strong>iOS Instructions</strong>
                                                                </p>
                                                                <ol className="wp-block-list">
                                                                    <li>
                                                                        Log in to the OLS and go to Mail &gt; Inbox.{" "}
                                                                        <strong>Your full email address is listed in the Account menu.</strong> Be sure to write
                                                                        it down or copy it to your clipboard.&nbsp;
                                                                    </li>
                                                                    <li>Download the Outlook for iOS application from the Apple Store.</li>
                                                                    <li>
                                                                        Once installed, open up the application and tap<strong> Settings &gt; Add Account</strong>
                                                                    </li>
                                                                    <li>
                                                                        On the <strong>“Add Account”</strong> page, tap<strong> Office 365</strong> and sign into
                                                                        your account using your full email address and your <strong>OLS password</strong>
                                                                    </li>
                                                                </ol>

                                                                <p>
                                                                    <strong>Android Instructions</strong>
                                                                </p>
                                                                <ol className="wp-block-list">
                                                                    <li>
                                                                        Log in to the OLS and go to Mail &gt; Inbox.{" "}
                                                                        <strong>Your full email address is listed in the Account menu.</strong> Be sure to write
                                                                        it down or copy it to your clipboard.
                                                                    </li>
                                                                    <li>Download the <strong>Outlook for Android</strong> application from the <strong>Google Play store</strong></li>
                                                                    <li>
                                                                        Once installed, open up the application and tap <strong>More</strong> &gt;{" "}
                                                                        <strong>Settings</strong> &gt; <strong>Add Account</strong>
                                                                    </li>
                                                                    <li>
                                                                        On the <strong>“Add Account”</strong> page, tap <strong>Office 365</strong> and sign into
                                                                        your account using your<strong> full email address</strong> and <strong>your OLS password</strong>
                                                                    </li>
                                                                </ol>

                                                                <p>
                                                                    Need to locate or update your account info? Access account settings on the My Account page at the top of this site, or in your OLS.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <span className="accordion-header" id="mobileHeader">
                                                            <button className={`accordion-button ${expandedSections.mobile ? '' : 'collapsed'}`} type="button"
                                                                onClick={() => toggleExpand('mobile')}
                                                                aria-expanded={expandedSections.mobile}
                                                                aria-controls="mobileContent"
                                                            >
                                                                <span className="show-more">Show More</span>
                                                                <span className="show-less">Show Less</span>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Topic Mark Read section */}
                        {currentChecklistId && <MarkTopicAsReadButton checklistId={currentChecklistId} />}

                    </div>
                </main>
            </div>
        </div>

    </div>
    <FooterMobile />
</div>
);
};
export default EmailOptions;